import { tryGetHostApi } from "../app/externalApi/externalApi";
import { addPartCData } from "./TraceLogging";
// Wrapper class for logging Measure events
// Measures are used to create MissionControl metrics, business metrics, and other metrics that require data from external devices
// Use of Measures _needs_ to be associated with a planned metric. When using this class, it is helpful to include a comment indicating which metric the event is supporting
// See https://www.osgwiki.com/wiki/Telemetry_categories for extra information
export class Measures {
    static async logEvent(provider, eventName, privacyTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 70368744177664 /* measures */, 0 /* none */, 0 /* verbose */, await addPartCData(partC));
        }
    }
    static async logEventWithTag(provider, eventName, privacyTag, eventTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 70368744177664 /* measures */, eventTag, 0 /* verbose */, await addPartCData(partC));
        }
    }
    static async logEventWithLevel(provider, eventName, privacyTag, loggingLevel, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 70368744177664 /* measures */, 0 /* none */, loggingLevel, await addPartCData(partC));
        }
    }
    static async logEventWithLevelAndTag(provider, eventName, privacyTag, loggingLevel, eventTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 70368744177664 /* measures */, eventTag, loggingLevel, await addPartCData(partC));
        }
    }
}
const pageTimings = typeof window !== "undefined" && (window._pageTimings || (window._pageTimings = {})) || {};
export function addMarkerToPageTimings(marker, value = undefined) {
    if (pageTimings[marker] === undefined) {
        pageTimings[marker] = value || Math.round(performance.now());
    }
}
